import React from 'react';
import { withTranslation } from 'config/i18n';
// Material UI core
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import MuLink from '@material-ui/core/Link';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import Hidden from '@material-ui/core/Hidden';
import useMediaQuery from '@material-ui/core/useMediaQuery';
// Material UI icons
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
// React components
import CurrencySelector from 'components/layout/TopBar/CurrencySelector';
import CountrySelector from 'components/layout/TopBar/CountrySelector';
import useFooterSitemap from 'data/useFooterSitemap';
import Link from 'components/shared/Link';
import NewsLetter from './NewsLetter';
import FollowUs from './FollowUs';

const Submenu = ({ category, classes, t }) => (
  <List dense>
    {category.submenu?.map((submenuItem) => (
      <ListItem key={submenuItem.text} className={classes.listItem}>
        <ListItemText
          primary={(
            <>
              {submenuItem.dataRoute
                ? (
                  <MuLink
                    className={classes.listItemLink}
                    href={submenuItem.href}
                    color="textSecondary"
                  >

                    {t(submenuItem.text)}

                  </MuLink>
                )
                : (
                  <Link
                    className={classes.listItemLink}
                    href={submenuItem.href}
                    color="textSecondary"
                  >

                    {t(submenuItem.text)}

                  </Link>
                )}
            </>
            )}
        />
      </ListItem>
    ))}
  </List>
);

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.secondary.main,
    padding: theme.spacing(5, 1),
    color: theme.palette.text.primary,
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(3, 1, 5),
    },
  },
  dialog: {
    marginBottom: '1.5rem',
    '& > *': {
      width: '100%',
      justifyContent: 'space-between',
    },
  },
  heading: {
    fontWeight: 700,
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: theme.typography.pxToRem(24),
    [theme.breakpoints.down('md')]: {
      fontWeight: 500,
      cursor: 'pointer',
      padding: theme.spacing(1.2, 0),
      color: theme.palette.text.secondary,
      textTransform: 'uppercase',
      fontSize: theme.typography.pxToRem(15),
      '&:hover,&.selected': {
        color: theme.palette.text.primary,
      },
    },
  },
  expandIcon: {
    fontSize: '1.25rem',
    [theme.breakpoints.up('lg')]: {
      display: 'none',
    },
  },
  listItem: {
    padding: [0, '!important'],
    "& [class*='MuiListItemText-root']": {
      margin: [0, '!important'],
    },
  },
  listItemLink: {
    display: 'flex',
    padding: theme.spacing(1.25, 0),
    fontSize: theme.typography.pxToRem(14),
    '&:hover': {
      color: theme.palette.text.primary,
    },
  },
}));

const Sitemap = ({ t }) => {
  const classes = useStyles();

  const footerSitemap = useFooterSitemap();

  const [categories, setCategories] = React.useState(footerSitemap);

  React.useEffect(() => {
    if (footerSitemap && footerSitemap.length > 0) {
      setCategories(footerSitemap);
    }
  }, [footerSitemap]);

  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down('md'));

  const toggleCategory = (category) => {
    if (!isMobileScreen) return;
    const index = categories.findIndex((c) => c.id === category.id);
    setCategories([
      // Collapse all categories except the current selected one
      ...categories.slice(0, index).map((c) => ({ ...c, isOpen: false })),
      {
        ...category,
        isOpen: !category.isOpen,
      },
      ...categories.slice(index + 1).map((c) => ({ ...c, isOpen: false })),
    ]);
  };

  return (
    <div className={classes.root}>
      <Container>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Hidden lgUp implementation="css">
              <Grid container spacing={4}>
                <Grid item xs={6} className={classes.dialog}>
                  <CurrencySelector />
                </Grid>
                <Grid item xs={6} className={classes.dialog}>
                  <CountrySelector />
                </Grid>
              </Grid>
            </Hidden>
          </Grid>
          <Grid item lg={9} xs={12}>
            <Grid container spacing={1}>
              {categories.map((category) => (
                <Grid item key={category.name} lg={4} xs={12}>
                  <Typography
                    variant="h5"
                    component="div"
                    className={
                      classes.heading + (category.isOpen ? ' selected' : '')
                    }
                    onClick={() => toggleCategory(category)}
                  >
                    {t(category.name)}
                    {' '}

                    <KeyboardArrowRightIcon className={classes.expandIcon} />
                  </Typography>
                  <Hidden lgUp implementation="css">
                    <Collapse in={category.isOpen} timeout="auto" unmountOnExit>
                      <Submenu category={category} classes={classes} t={t} />
                    </Collapse>
                  </Hidden>
                  <Hidden mdDown implementation="css">
                    <Submenu category={category} classes={classes} t={t} />
                  </Hidden>
                </Grid>
              ))}
            </Grid>
          </Grid>
          <Grid item lg={3} sm={12}>
            <FollowUs title={t('layout:footer.follow_us')} />
            <NewsLetter />
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default withTranslation([
  'layout',
  'fe_eaglerider_information',
  'eaglerider_information',
])(Sitemap);
